/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Realtime_Errors_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Show real-time errors" |
*
* @param {Event_Realtime_Errors_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_realtime_errors_aria_label = /** @type {((inputs?: Event_Realtime_Errors_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Realtime_Errors_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les erreurs en temps reel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Echtzeitfehler anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra errori in tempo reale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отображение ошибок в реальном времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar errores en tiempo real")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示实时误差")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リアルタイムエラーを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वास्तविक समय की त्रुटियाँ दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exibir erros em tempo real")
	return /** @type {LocalizedString} */ ("Show real-time errors")
});